import { BaseContainerModel } from '../base-container.model';
import {
  bl_fi_generic_doc_link_RowInterface,
} from '../../dbschema/index';

export class GenericDocLinkContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_link: bl_fi_generic_doc_link_RowInterface[] = new Array();
}
